import type { CasaLeonOperationalEvent, CasaLeonSector } from '@casa-leon-vivo/contracts/casa-leon';

let seq = 0;
export function resetIntegralDemoSeq(): void {
  seq = 0;
}

function evt<T extends CasaLeonOperationalEvent['type']>(
  base: Omit<CasaLeonOperationalEvent, 'id' | 'timestamp'> & { type: T },
): CasaLeonOperationalEvent {
  seq += 1;
  return { ...base, id: `integral-${seq}`, timestamp: 2_000_000 + seq } as CasaLeonOperationalEvent;
}

function openTable(
  tableId: string,
  sector: 'salon' | 'patio',
  partySize: number,
  sectorEvt: CasaLeonSector = 'salon',
): CasaLeonOperationalEvent {
  return evt({
    businessId: 'casa-leon',
    sector: sectorEvt,
    type: 'table.session.open',
    simulated: true,
    entity: { kind: 'table', id: tableId },
    origin: 'simulator',
    payload: { tableId, sector, partySize, staffId: 'mozo-1', label: `Mesa ${tableId}` },
  });
}

/** 1. Apertura */
export function scenario01Apertura(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'caja',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'caja' },
      origin: 'simulator',
      payload: { activity: 'caja_apertura' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'staff.presence',
      simulated: true,
      entity: { kind: 'staff', id: 'mozo-1' },
      origin: 'simulator',
      payload: {
        staffId: 'mozo-1',
        displayName: 'Luc�a',
        role: 'mozo',
        presence: 'shift',
        priority: 2,
      },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'entrada_proveedores',
      type: 'supplier.arrival',
      simulated: true,
      entity: { kind: 'sector', id: 'proveedores' },
      origin: 'simulator',
      payload: { supplierName: 'Distribuidora Norte (simulado)' },
    }),
  ];
}

/** 2. Llegada de grupos 2,4,10,20,30 */
export function scenario02Grupos(): CasaLeonOperationalEvent[] {
  return [
    openTable('S-02', 'salon', 2),
    openTable('S-04', 'salon', 4),
    openTable('S-10', 'salon', 10),
    openTable('P-20', 'patio', 20, 'patio'),
    openTable('P-30', 'patio', 30, 'patio'),
  ];
}

/** 3. Servicio simult�neo */
export function scenario03ServicioSimultaneo(): CasaLeonOperationalEvent[] {
  return [
    ...scenario02Grupos().slice(0, 3),
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'table.session.state',
      simulated: true,
      entity: { kind: 'table', id: 'S-02' },
      origin: 'simulator',
      payload: { tableId: 'S-02', operationalState: 'pedido_activo' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'table.session.state',
      simulated: true,
      entity: { kind: 'table', id: 'S-04' },
      origin: 'simulator',
      payload: { tableId: 'S-04', operationalState: 'pedido_activo' },
    }),
  ];
}

/** 4. Barra, cocina, parrilla */
export function scenario04Produccion(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'barra',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'barra' },
      origin: 'simulator',
      payload: { activity: 'bebida_preparacion' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'cocina',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'cocina' },
      origin: 'simulator',
      payload: { activity: 'cocina_pedido' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'parrilla',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'parrilla' },
      origin: 'simulator',
      payload: { activity: 'parrilla_cocinando' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'pasteleria',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'pasteleria' },
      origin: 'simulator',
      payload: { activity: 'pasteleria_pedido' },
    }),
  ];
}

/** 5. Takeaway */
export function scenario05Takeaway(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'caja',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'caja' },
      origin: 'simulator',
      payload: { activity: 'caja_cobro', detail: 'takeaway-T1' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'cocina',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'cocina' },
      origin: 'simulator',
      payload: { activity: 'cocina_listo', detail: 'takeaway-T1' },
    }),
  ];
}

/** 6. Delivery */
export function scenario06Delivery(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'delivery',
      type: 'delivery.lifecycle',
      simulated: true,
      entity: { kind: 'delivery', id: 'D-1' },
      origin: 'simulator',
      payload: { deliveryId: 'D-1', phase: 'preparacion' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'delivery',
      type: 'delivery.lifecycle',
      simulated: true,
      entity: { kind: 'delivery', id: 'D-1' },
      origin: 'simulator',
      payload: { deliveryId: 'D-1', phase: 'en_camino' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'delivery',
      type: 'delivery.lifecycle',
      simulated: true,
      entity: { kind: 'delivery', id: 'D-1' },
      origin: 'simulator',
      payload: { deliveryId: 'D-1', phase: 'entregado' },
    }),
  ];
}

/** 7. Reposici�n */
export function scenario07Reposicion(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'deposito',
      type: 'stock.movement',
      simulated: true,
      entity: { kind: 'sector', id: 'deposito' },
      origin: 'simulator',
      payload: { sku: 'carne', delta: 12 },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'deposito',
      type: 'stock.movement',
      simulated: true,
      entity: { kind: 'sector', id: 'deposito' },
      origin: 'simulator',
      payload: { sku: 'verduras', delta: 8 },
    }),
  ];
}

/** 8. Cobros y liberaci�n */
export function scenario08CobrosYLiberacion(): CasaLeonOperationalEvent[] {
  const tableId = 'S-04';
  return [
    openTable(tableId, 'salon', 4),
    evt({
      businessId: 'casa-leon',
      sector: 'caja',
      type: 'payment.registered',
      simulated: true,
      entity: { kind: 'register', id: 'caja' },
      origin: 'simulator',
      payload: { amount: 120, method: 'simulado' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'table.session.release',
      simulated: true,
      entity: { kind: 'table', id: tableId },
      origin: 'simulator',
      payload: { tableId },
    }),
  ];
}

/** 9. Cambio de personal */
export function scenario09CambioPersonal(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'staff.presence',
      simulated: true,
      entity: { kind: 'staff', id: 'mozo-1' },
      origin: 'simulator',
      payload: {
        staffId: 'mozo-1',
        displayName: 'Luc�a',
        role: 'mozo',
        presence: 'off',
        priority: 2,
      },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'staff.presence',
      simulated: true,
      entity: { kind: 'staff', id: 'mozo-2' },
      origin: 'simulator',
      payload: {
        staffId: 'mozo-2',
        displayName: 'Tom�s',
        role: 'mozo',
        presence: 'manual_floor',
        priority: 1,
      },
    }),
  ];
}

/** 10. Cierre */
export function scenario10Cierre(): CasaLeonOperationalEvent[] {
  return [
    evt({
      businessId: 'casa-leon',
      sector: 'caja',
      type: 'sector.activity',
      simulated: true,
      entity: { kind: 'sector', id: 'caja' },
      origin: 'simulator',
      payload: { activity: 'caja_cobro', detail: 'cierre' },
    }),
    evt({
      businessId: 'casa-leon',
      sector: 'salon',
      type: 'staff.presence',
      simulated: true,
      entity: { kind: 'staff', id: 'mozo-2' },
      origin: 'simulator',
      payload: {
        staffId: 'mozo-2',
        displayName: 'Tom�s',
        role: 'mozo',
        presence: 'off',
        priority: 1,
      },
    }),
  ];
}

export const INTEGRAL_SCENARIOS: Record<string, () => CasaLeonOperationalEvent[]> = {
  '1-apertura': scenario01Apertura,
  '2-grupos': scenario02Grupos,
  '3-servicio': scenario03ServicioSimultaneo,
  '4-produccion': scenario04Produccion,
  '5-takeaway': scenario05Takeaway,
  '6-delivery': scenario06Delivery,
  '7-reposicion': scenario07Reposicion,
  '8-cobros': scenario08CobrosYLiberacion,
  '9-personal': scenario09CambioPersonal,
  '10-cierre': scenario10Cierre,
};
